import type { RouteRecordRaw } from 'vue-router'
import { efficiencyRouteCandidates, toAnyPermission } from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createEfficiencyChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: '',
    ...maybeRouteName(withNames, 'efficiency'),
    component: () => import('@/views/efficiency/EfficiencyOverview.vue'),
    meta: { permission: 'efficiency:overview:view' }
  },
  {
    path: 'requirement-time',
    ...maybeRouteName(withNames, 'efficiency-requirement-time'),
    component: () => import('@/views/efficiency/EfficiencyTimeAnalysis.vue'),
    meta: { permission: 'efficiency:overview:view' }
  },
  {
    path: 'story-point-time',
    ...maybeRouteName(withNames, 'efficiency-story-point-time'),
    component: () => import('@/views/efficiency/EfficiencyStoryPointAnalysis.vue'),
    meta: { permission: 'efficiency:overview:view' }
  },
  {
    path: 'rankings',
    ...maybeRouteName(withNames, 'efficiency-rankings'),
    component: () => import('@/views/efficiency/EfficiencyRanking.vue'),
    meta: { permission: 'efficiency:ranking:view' }
  }
]

const efficiencyRoutes: RouteRecordRaw[] = [
  {
    path: 't/:tenantCode/efficiency',
    component: () => import('@/views/efficiency/EfficiencyLayout.vue'),
    meta: {
      permission: toAnyPermission(efficiencyRouteCandidates),
      defaultRouteBasePath: '/t/:tenantCode/efficiency',
      defaultRouteCandidates: efficiencyRouteCandidates,
    },
    children: createEfficiencyChildren(true)
  },
  {
    path: 'efficiency',
    component: () => import('@/views/efficiency/EfficiencyLayout.vue'),
    beforeEnter: legacyTenantRedirect,
    meta: {
      permission: toAnyPermission(efficiencyRouteCandidates),
      defaultRouteBasePath: '/efficiency',
      defaultRouteCandidates: efficiencyRouteCandidates,
      legacyTenantRedirect: true,
    },
    children: createEfficiencyChildren(false)
  }
]

export default efficiencyRoutes
